export const pricingPlans = [
  {
    name: "Blue Tier",
    tier: "blue",
    requestRange: "First 5 Requests",
    originalPrice: "1,000",
    price: "700",
    unit: "/ Request",
    discount: "Save 30%",
    subtitle: "For occasional requests or new users",
    features: [
      "Full PRO access",
      "Online dashboard & tracking",
      "Government slip management",
      "Standard processing",
    ],
    payAsYouGo: {
      title: "Flexible Pay-As-You-Go",
      bullets: [
        "No monthly commitment",
        "Automatic upgrades",
      ],
      tiers: [
        { range: "1\u20135 requests", tier: "Blue" },
        { range: "+6", tier: "Silver" },
        { range: "+25", tier: "Gold" },
        { range: "+49", tier: "Platinum" },
      ],
      note: "No manual upgrade required. Your tier adjusts automatically based on usage.",
      retention:
        "Once you qualify for a tier, you keep that pricing for 12 months from the qualification date.",
    },
    buttonText: "GET STARTED NOW",
    popular: false,
  },
  {
    name: "Silver Tier",
    tier: "silver",
    requestRange: "6\u201324 Requests",
    originalPrice: "1,000",
    price: "480",
    unit: "/ Request",
    discount: "Save 52%",
    subtitle: "For growing businesses submitting multiple requests",
    features: [
      "Everything in Blue",
      "Semi-dedicated account manager",
      "Priority handling",
      "24/7 online support",
    ],
    subscription: {
      title: "Lock in Silver from Day One",
      subtitle: "with monthly subscription",
      requests: "1+ requests",
    },
    annual: {
      title: "Save More with Annual Prepayment",
      requests: "6+ requests",
      price: "430",
      discount: "10% Discount",
    },
    buttonText: "AVAIL IT NOW",
    popular: false,
  },
  {
    name: "Gold Tier",
    tier: "gold",
    requestRange: "25\u201348 Requests",
    originalPrice: "1,000",
    price: "340",
    unit: "/ Request",
    discount: "Save 66%",
    subtitle: "Optimized for active teams handling many PRO requests",
    features: [
      "Dedicated relationship manager",
      "Express processing",
      "Operational optimization support",
    ],
    subscription: {
      title: "Lock in Gold from Day One",
      subtitle: "with monthly subscription",
      requests: "3+ requests",
    },
    annual: {
      title: "Save More with Annual Prepayment",
      requests: "25+ requests",
      price: "300",
      discount: "10% Discount",
    },
    buttonText: "AVAIL IT NOW",
    popular: true,
  },
  {
    name: "Platinum Tier",
    tier: "platinum",
    requestRange: "+49 Requests",
    originalPrice: "1,000",
    price: "220",
    unit: "/ Request",
    discount: "Save 78%",
    subtitle: "Premium solution for high-volume or enterprise users",
    features: [
      "Priority SLA & support",
      "Enterprise-level coordination",
      "Compliance advisory",
      "Custom reporting",
      "Premium support",
    ],
    subscription: {
      title: "Lock in Platinum from Day One",
      subtitle: "with monthly subscription",
      requests: "5+ requests",
    },
    annual: {
      title: "Save More with Annual Prepayment",
      requests: "49+ requests",
      price: "200",
      discount: "10% Discount",
    },
    buttonText: "AVAIL IT NOW",
    popular: false,
  },
  {
    name: "Enterprise",
    tier: "enterprise",
    subtitle: "Custom solutions for high-volume or complex needs.",
    description:
      "Dedicated support and tailored service structures.",
    buttonText: "CONTACT US FOR APP ACCESS",
    popular: false,
  },
];
